(() => {
  const config = window.FANGSTER_R10 || {};
  const routes = window.FANGSTER_ROUTES || {};
  const strings = (window.FANGSTER_I18N && window.FANGSTER_I18N.strings) || {};
  const rootPath = new URL(routes.root || '/', window.location.origin).pathname.replace(/\/$/, '');
  const storefrontPath = (pathname) => rootPath && pathname.startsWith(`${rootPath}/`)
    ? pathname.slice(rootPath.length)
    : pathname;
  const localPath = (pathname) => `${rootPath}${pathname.startsWith('/') ? pathname : `/${pathname}`}` || '/';

  const ensureFavicon = () => {
    if (!config.faviconUrl || !document.head) return;

    const existingIcons = document.querySelectorAll(
      'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]'
    );

    existingIcons.forEach((link) => {
      if (link.rel === 'apple-touch-icon') {
        link.href = config.touchIconUrl || config.faviconUrl;
        link.setAttribute('sizes', '180x180');
      } else {
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = config.faviconUrl;
        link.setAttribute('sizes', '32x32');
      }
      link.setAttribute('data-fangster-favicon', 'true');
    });

    if (!document.querySelector('link[rel="icon"][data-fangster-favicon="true"]')) {
      const icon = document.createElement('link');
      icon.rel = 'icon';
      icon.type = 'image/png';
      icon.sizes = '32x32';
      icon.href = config.faviconUrl;
      icon.setAttribute('data-fangster-favicon', 'true');
      document.head.appendChild(icon);
    }

    if (!document.querySelector('link[rel="apple-touch-icon"][data-fangster-favicon="true"]')) {
      const touchIcon = document.createElement('link');
      touchIcon.rel = 'apple-touch-icon';
      touchIcon.sizes = '180x180';
      touchIcon.href = config.touchIconUrl || config.faviconUrl;
      touchIcon.setAttribute('data-fangster-favicon', 'true');
      document.head.appendChild(touchIcon);
    }
  };

  const enhanceSearch = () => {
    if (storefrontPath(window.location.pathname) !== '/search') return;

    const input = document.querySelector('#Search-In-Template');
    if (input) {
      const label = strings.searchProductLabel || 'Search SKU, part number, brand, or product name';
      input.placeholder = label;
      input.setAttribute('aria-label', label);
      const fieldLabel = document.querySelector('label[for="Search-In-Template"]');
      if (fieldLabel) fieldLabel.textContent = label;
    }

    const searchBlock = document.querySelector('.template-search__search');
    if (searchBlock && !document.querySelector('.fg-search-guidance')) {
      const guidance = document.createElement('p');
      guidance.className = 'fg-search-guidance';
      guidance.textContent = strings.searchGuidance || 'For the fastest match, enter an exact SKU, part number, or OEM reference. Brand and product-name searches are also supported.';
      searchBlock.insertAdjacentElement('afterend', guidance);
    }

    const hasQuery = Boolean(new URLSearchParams(window.location.search).get('q'));
    const emptyState = document.querySelector('.template-search--empty');
    const header = document.querySelector('.template-search__header');
    if (hasQuery && emptyState && header && !document.querySelector('.fg-search-empty-actions')) {
      const actions = document.createElement('div');
      actions.className = 'fg-search-empty-actions';
      actions.setAttribute('aria-label', strings.continueShopping || 'Continue shopping');
      actions.innerHTML = [
        `<a href="${routes.shopByPart || localPath('/pages/shop-by-part')}">${strings.shopByPart || 'Shop by Part'}</a>`,
        `<a href="${routes.shopByBrand || localPath('/pages/shop-by-brand')}">${strings.shopByBrand || 'Shop by Brand'}</a>`,
        `<a href="${routes.contact || localPath('/pages/contact-us')}">${strings.askFangster || 'Ask FANGSTER'}</a>`
      ].join('');
      header.appendChild(actions);
    }
  };

  ensureFavicon();

  const apply = () => {
    ensureFavicon();
    enhanceSearch();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);
})();
